import styled from 'styled-components';
import { FlexListItem } from 'styles';

export const FileItem = styled(FlexListItem)`
  padding: 8px 32px;
  border-radius: 4px;
  gap: 10px;
  width: 256px;
`;
